<progress
  class="progress-bar"
  [ngClass]="{ primary: hasPrimaryColors }"
  [max]="displayMax"
  [value]="displayValue"></progress>
<div class="percentage" *ngIf="displayAsPercent">{{ displayValue }}% complete</div>
